// extracted by mini-css-extract-plugin
module.exports = {"parameter-issues":"ParameterIssues_parameter-issues_2gG2C"};